import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import SummaryApi from '../common'
import displayINRCurrency from '../helpers/displayCurrency'
import moment from 'moment'
import * as XLSX from 'xlsx';
import { SiMicrosoftexcel } from "react-icons/si";
import { useNavigate } from 'react-router-dom'
import ROLE from '../common/role'
import { useSelector } from 'react-redux'
import { AiOutlineLoading3Quarters } from 'react-icons/ai'

const AdminBossSearchProduct = () => {
    const user = useSelector(state => state?.user?.user);
    const [loadingPage, setLoadingPage] = useState(true);
    const navigate = useNavigate();
    const query = useLocation()
    const [data,setData] = useState([])
    const [loading,setLoading] = useState(false)
    const [startDate, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'));
    const [governorate,setGovernorate] = useState('');
    const [region,setRegion] = useState('');
    const [pharmacy,setPharmacy] = useState('');
    const [pharmacies,setPharmacies] = useState([]);
    const [salesman,setSalesman] = useState('');
    const [salesmen,setSalesmen] = useState([]);
    const [brand,setBrand] = useState('');
    const [type,setType] = useState('');


    const fetchPharmacies = async (gov,reg) => {
        try {
          const response = await fetch(SummaryApi.getPharmacies.url, {
            method: SummaryApi.getPharmacies.method,
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                 governorate: gov,
                 region : reg,
            })
          });
          const result =await response.json();
          if(result.success){
            setPharmacies(result.data || [])
          }
      
        } catch (error) {
        }
      };


      const fetchSalesMen = async () => {
        try {
          const response = await fetch(SummaryApi.getSales.url, {
            method: SummaryApi.getSales.method,
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify()
          });
          const result =await response.json();
          if(result.success){
            setSalesmen(result.data || [])
          }
      
        } catch (error) {
        }
      };


    const fetchProduct = async(que,stDate, eDate,gov,reg,pharma,salesmann,brandd,typee)=>{
        setLoading(true)
        const response1 = await fetch(SummaryApi.searchOrderProduct.url,{
            method: SummaryApi.searchOrderProduct.method,
            credentials: 'include',
            headers: {
              "Content-Type": 'application/json'
            },
            body: JSON.stringify({
                query:que.search,
                startDate: stDate ? moment(stDate).toISOString() : '',
                endDate: eDate ? moment(eDate).toISOString() : '',
                governorate : gov,
                region: reg ,
                pharmacy: pharma,
                salesman:salesmann,
                brand:brandd,
                type:typee

            })
          })
        const response2 = await fetch(SummaryApi.searchOrderCosmeticProduct.url,{
            method: SummaryApi.searchOrderCosmeticProduct.method,
            credentials: 'include',
            headers: {
              "Content-Type": 'application/json'
            },
            body: JSON.stringify({
                query:que.search,
                startDate: stDate ? moment(stDate).toISOString() : '',
                endDate: eDate ? moment(eDate).toISOString() : '',
                governorate : gov,
                region: reg ,
                pharmacy: pharma,
                salesman:salesmann,
                brand:brandd,
                type:typee
            })
          })
        const dataResponse1 = await response1.json()
        const dataResponse2 = await response2.json()
        const combinedData = [
          ...(dataResponse1.data || []),
          ...(dataResponse2.data || [])
      ]

      
        setLoading(false)

        setData(combinedData)
    }

    useEffect(()=>{
        fetchSalesMen()
        fetchPharmacies(governorate||'',region||'')
        fetchProduct(query,startDate, endDate,governorate||'',region||'',pharmacy||'',salesman||'',brand||'',type||'')
    },[query,startDate, endDate,governorate,region,pharmacy,salesman,brand,type])

    const downloadExcel = () => {
      
      const dataToDownload = data.map(({  productName, productActivePharmaceuticalIngredient, productUnits, productValue }) => ({
          'اسم المنتج': productName,
          'اسم المادة الفعالة': productActivePharmaceuticalIngredient,
          'الكمية': productUnits,
          'السعر الإجمالى': displayINRCurrency(productValue),
          
      }));

      const worksheet = XLSX.utils.json_to_sheet(dataToDownload);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Products");

      
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

      
      const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `products_${moment().format('YYYYMMDD_HHmmss')}.xlsx`;
      link.click();
  }


  useEffect(() => {
    setLoadingPage(true);
    const loadingTimeout = setTimeout(() => {
      
      setLoadingPage(false);
      navigate("/");
    }, 10000); 

    if (user) {
      if (user?.role !== ROLE.ADMIN ) {
        
        navigate("/");
        setLoadingPage(false);
      } 
      else if(user?.type==="Cosmetic"){
        navigate('/admin-cosmetic-home')
        setLoadingPage(false);

      }
      else if(user?.type==="Medicine"){
        navigate('/admin-home');
        setLoadingPage(false);

      }
      else {
        setLoadingPage(false);
        clearTimeout(loadingTimeout)
      }
    } 

    // Clear the timeout when the component unmounts or the effect is rerun
    return () => clearTimeout(loadingTimeout);
  }, [user, navigate]);

  
  if (loadingPage) {
    return (
      <div className="flex justify-center items-center h-screen">
        <AiOutlineLoading3Quarters className="animate-spin text-6xl text-blue-500" />
      </div>
    );
  }

  return (
    <div className='container mx-auto p-4'>
      {
        loading && (
          <p className='text-lg text-center '>... جارى التحميل</p>
        )
      }
 
      <p className='text-xl font-semibold text-right'> {data.length} : نتائج البحث</p>

      {
        data.length === 0 && !loading && (
           <p className='bg-white text-lg text-center p-4'>...لم يتم العثور علي بيانات </p>
        )
      }

          {/* Date Filter Section */}
              
             
          <div className="flex justify-end items-start mb-4">
                      <div className="text-right">
                      
  
                        <div className="flex gap-6 justify-end">
                         
                         
                        <div className="flex flex-wrap justify-between items-center gap-4 mb-4">
                        <div className="w-full sm:w-auto flex-1">
                          <label htmlFor="type" className="block text-sm font-medium text-gray-700">
                            نوع العملية 
                          </label>
                          <select
                            name="type"
                            value={type}
                            onChange={(e) => {
                              setType(e.target.value);
                              
                            }}
                            className="bg-white p-1 sm:p-2 w-full outline-none mt-1 block border border-gray-300 rounded-md text-sm sm:text-base"
                          >
                            <option value="">جميع العمليات</option>
                            <option value="order">المبيعات</option>
                            <option value="refund">المرتجعات</option>
                            <option value="processing">قيد المراجعة</option>
                          </select>
                        </div>
                        <div className="w-full sm:w-auto flex-1">
                          <label htmlFor="brand" className="block text-sm font-medium text-gray-700">
                            العلامة التجارية 
                          </label>
                          <select
                            name="brand"
                            value={brand}
                            onChange={(e) => {
                              setBrand(e.target.value);
                              
                            }}
                            className="bg-white p-1 sm:p-2 w-full outline-none mt-1 block border border-gray-300 rounded-md text-sm sm:text-base"
                          >
                            <option value="">جميع العلامات</option>
                            <option value="yasenka">yasenka</option>
                            <option value="XEN">XEN</option>
                            <option value="TECO PHARMA">TECO PHARMA</option>
                            <option value="Rito">Rito</option>
                          </select>
                        </div>
                        <div className="w-full sm:w-auto flex-1">
                      <label htmlFor="salesman" className="block text-sm font-medium text-gray-700">
                        مندوب المبيعات 
                      </label>
                      <select
                        name="salesman"
                        value={salesman}
                        onChange={(e) => setSalesman(e.target.value)}
                        className="bg-white p-1 sm:p-2 w-full outline-none mt-1 block border border-gray-300 rounded-md text-sm sm:text-base"
                      >
                        <option value=''>{salesmen?.length === 0 ? 'لا يوجد مندوبين مبيعات' : 'جميع المندوبين'}</option>
                                          {Array.isArray(salesmen)&&salesmen?.map(sales => (
                                            <option key={sales._id} value={sales.name}>
                                              {sales.name}
                                            </option>
                                          ))}
                      </select>
                    </div>
                        <div className="w-full sm:w-auto flex-1">
                      <label htmlFor="pharmacy" className="block text-sm font-medium text-gray-700">
                      الصيدلية/العميل 
                      </label>
                      <select
                        name="pharmacy"
                        value={pharmacy}
                        onChange={(e) => setPharmacy(e.target.value)}
                        className="bg-white p-1 sm:p-2 w-full outline-none mt-1 block border border-gray-300 rounded-md text-sm sm:text-base"
                      >
                        <option value=''>{pharmacies?.length === 0 ? 'لا يوجد صيدليات/عملاء' : 'جميع الصيدليات'}</option>
                                          {Array.isArray(pharmacies)&&pharmacies?.map(pharmacy => (
                                            <option key={pharmacy._id} value={pharmacy.name}>
                                              {pharmacy.name}
                                            </option>
                                          ))}
                      </select>
                    </div>


                    {governorate==='طرابلس' && (                    
                                        <div className="w-full sm:w-auto flex-1">
                    <label htmlFor="region" className="block text-sm font-medium text-gray-700">
                      المنطقة 
                    </label>
                    <select
                                  name='region'
                                  value={region}
                                  onChange={(e) => {
                                    setRegion(e.target.value); 
                                    setPharmacy('');
                                    setPharmacies([]);
                                
                                    
                                  }}
                                  className="bg-white p-1 sm:p-2 w-full outline-none mt-1 block border border-gray-300 rounded-md text-sm sm:text-base"
                                >
                                  <option value=''>جميع المناطق</option>
                                  <option value='وسط المدينة'>وسط المدينة</option>
                                  <option value='حي الاندلس'>حي الاندلس</option>
                                  <option value='قرقارش'>قرقارش</option>
                                  <option value='جنزور'>جنزور</option>
                                  <option value='غوط الشغال'>غوط الشغال</option>
                                  <option value='سوق الجمعة'>سوق الجمعة</option>
                                  <option value='تاجوراء'>تاجوراء</option>
                                  <option value='قصر بن غشير'>قصر بن غشير</option>
                                  <option value='سبيعة'> سبيعة </option>
                                  <option value='عين زارة'>عين زارة</option>
                                  <option value='الهضبة'>الهضبة</option>
                                  <option value='ابوسليم'>ابوسليم</option>
                                  <option value='الفرناج'>الفرناج</option>
                                </select>
                  </div>     
                    )}


                          <div className="w-full sm:w-auto flex-1">
                          <label htmlFor="governorate" className="block text-sm font-medium text-gray-700">
                            المدينة 
                          </label>
                          <select
                            name="governorate"
                            value={governorate}
                            onChange={(e) => {
                              setRegion(''); 
                              setPharmacy('');
                              setGovernorate(e.target.value);
                              setPharmacies([]);
                              
                            }}
                            className="bg-white p-1 sm:p-2 w-full outline-none mt-1 block border border-gray-300 rounded-md text-sm sm:text-base"
                          >
                            <option value="">جميع المدن</option>
                            <option value="طرابلس">طرابلس</option>
                            <option value="بني غازي">بني غازي</option>
                            <option value="مصراتة">مصراتة</option>
                            <option value="الزاوية">الزاوية</option>
                            <option value="زليتن">زليتن</option>
                            <option value="الخمس">الخمس</option>
                            <option value="ترهونة">ترهونة</option>
                            <option value="قربولي">قربولي</option>
                            <option value="الجنوب">الجنوب</option>
                            <option value="منطقة اخري">منطقة اخري</option>
                          </select>
                        </div>




                          
                          
                          
                        <div className="w-full sm:w-auto flex-1">
                            <label htmlFor="endDate" className="block text-sm font-medium text-gray-700">
                              تاريخ النهاية
                            </label>
                            <input
                              type="date"
                              id="endDate"
                              value={endDate}
                              onChange={(e) => setEndDate(e.target.value)}
                              className="mt-1 p-1 sm:p-2 block w-full border border-gray-300 rounded-md text-sm sm:text-base"
                            />
                          </div>
                          <div className="w-full sm:w-auto flex-1">
                            <label htmlFor="startDate" className="block text-sm font-medium text-gray-700">
                              تاريخ البداية
                            </label>
                            <input
                              type="date"
                              id="startDate"
                              value={startDate}
                              onChange={(e) => setStartDate(e.target.value)}
                              className="mt-1 p-1 sm:p-2 block w-full border border-gray-300 rounded-md text-sm sm:text-base"
                            />
                          </div>
                          
                        </div>
                        </div>
                       
                      </div>
                    </div>
      {data.length !==0 && !loading && (    
         <div>

      <div className="flex justify-end mb-4">
          <button
              onClick={downloadExcel}
              className="flex items-center bg-green-600 text-white py-2 px-4 rounded-lg shadow-md transition duration-200 ease-in-out hover:bg-green-700 hover:shadow-lg"
          >
              <SiMicrosoftexcel className="mr-2 text-lg" />
              Excel تحميل البيانات ك ملف 
          </button>
      </div>

          {/* Main content */}
          <main className="w-full h-full p-4">

                    
  
          
            <div className="overflow-x-auto">
              <table className="w-full border-collapse border border-gray-300">
                <thead>
                  <tr className="bg-black text-white">
                    <th className="py-2 px-4 border border-gray-300">الترتيب</th>
                    <th className="py-2 px-4 border border-gray-300">اسم المنتج</th>
                    <th className="py-2 px-4 border border-gray-300">المادة الفعالة</th>
                    <th className="py-2 px-4 border border-gray-300">الكمية</th>
                    {type!=="refund" && type!=="processing" &&(

                      <th className="py-2 px-4 border border-gray-300">البونص</th>
                    )}
                   
                    <th className="py-2 px-4 border border-gray-300">السعر الإجمالى</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, index) => (
                    <tr key={item._id || index} className="min-h-[80px] border-t border-gray-300">
                      <td className="text-center py-2 px-4 border border-gray-300">{index + 1}</td>
                      <td className="text-center py-2 px-4 border border-gray-300">{item.productName}</td>
                      <td className="text-center py-2 px-4 border border-gray-300">{item.productActivePharmaceuticalIngredient}</td>
                      <td className="text-center py-2 px-4 border border-gray-300">{item.productUnits}</td>
                      {type!=="refund" && type!=="processing" &&(
                      <td className="text-center py-2 px-4 border border-gray-300">{item.bonus}</td>
                      )}
                      <td className="text-center py-2 px-4 border border-gray-300">{displayINRCurrency(item.productValue)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          
        </main>
        </div>
        )
      }

    </div>
  )
}

export default AdminBossSearchProduct